export type UiHttpErrorKind = "abort" | "network" | "timeout" | "http";

export type UiHttpErrorFields = {
    kind: UiHttpErrorKind;
    url: string;
    method: string;
    statusCode?: number;
    body?: unknown;
};

export class UiHttpError extends Error implements UiHttpErrorFields {
    readonly kind: UiHttpErrorKind;
    readonly url: string;
    readonly method: string;
    readonly statusCode?: number;
    readonly body?: unknown;

    constructor(message: string, fields: UiHttpErrorFields) {
        super(message);
        this.name = "UiHttpError";
        this.kind = fields.kind;
        this.url = fields.url;
        this.method = fields.method;
        this.statusCode = fields.statusCode;
        this.body = fields.body;
    }

    getServerErrorMessage(): string {
        if (typeof this.body === "object" && this.body !== null && "message" in this.body) {
            return this.body.message as string;
        }
        return this.message;
    }
}

export function isUiHttpError(error: unknown): error is UiHttpError {
    return error instanceof UiHttpError;
}
